"use client";

import React from "react";
import { ArrowRight, Hammer, Paintbrush, Shovel } from "lucide-react";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const projects = [{
  title: "Modern Kitchen Overhaul",
  service: "Whole House Remodels",
  beforeImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/kitchen_remodel_before.png",
  afterImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/kitchen_remodel_after.png",
  icon: Hammer
}, {
  title: "Master Bath Spa Retreat",
  service: "Whole House Remodels",
  beforeImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/bathroom_renovation_before.png",
  afterImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/bathroom_renovation_after.png",
  icon: Paintbrush
}, {
  title: "Deck Restoration & Stain",
  service: "Handyman Work",
  beforeImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/deck_repair_before.png",
  afterImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/deck_repair_after.png",
  icon: Hammer
}, {
  title: "Living Room Open Concept",
  service: "Whole House Remodels",
  beforeImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/living_room_update_before.png",
  afterImg: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1557890/img/living_room_update_after.png",
  icon: Paintbrush
}];
export default function TheTransformationVault() {
  return <section id="the-transformation-vault" className="dark bg-background text-foreground py-16 px-4 md:py-24">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 text-center space-y-4">
          <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-foreground">
            The Transformation Vault
          </h2>
          <p className="text-muted-foreground max-w-2xl mx-auto text-lg">
            Witness the power of professional craftsmanship. Explore our
            before-and-after gallery showcasing whole-house remodels and
            detailed handyman work.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {projects.map((project, i) => <Card key={i} data-index={i} className="group relative overflow-hidden border-border bg-card rounded-xl p-0 border-0 shadow-md">
              <AspectRatio ratio={4 / 3}>
                {}
                <div className="absolute inset-0 w-full h-full transition-transform duration-500 ease-out group-hover:scale-105">
                  {}
                  <div className="absolute inset-y-0 left-0 w-1/2 overflow-hidden">
                    <img src={project.beforeImg} alt={`${project.title} Before`} className="absolute inset-0 h-full w-[200%] max-w-none object-cover object-left" />
                    <div className="absolute bottom-2 left-2 bg-black/60 text-white text-xs px-2 py-1 rounded-sm backdrop-blur-sm font-medium">
                      Before
                    </div>
                  </div>

                  {}
                  <div className="absolute inset-y-0 right-0 w-1/2 overflow-hidden">
                    <img src={project.afterImg} alt={`${project.title} After`} className="absolute inset-0 h-full w-[200%] max-w-none object-cover object-right ml-[-100%]" />
                    <div className="absolute bottom-2 right-2 bg-primary/80 text-primary-foreground text-xs px-2 py-1 rounded-sm backdrop-blur-sm font-medium">
                      After
                    </div>
                  </div>

                  {}
                  <div className="absolute inset-y-0 left-1/2 w-0.5 bg-white/80 shadow-[0_0_10px_rgba(0,0,0,0.5)] z-10"></div>
                </div>

                {}
                <div className="absolute inset-0 bg-primary/90 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col items-center justify-center text-center p-6 z-20">
                  <div className="bg-background/20 p-3 rounded-full mb-3 backdrop-blur-sm text-white">
                    <project.icon className="w-6 h-6" />
                  </div>
                  <h3 className="text-xl font-bold text-white mb-1">
                    {project.title}
                  </h3>
                  <p className="text-white/90 font-medium text-sm uppercase tracking-wider">
                    {project.service}
                  </p>
                </div>
              </AspectRatio>
            </Card>)}
        </div>

        <div className="mt-12 text-center">
          <Button asChild size="lg" className="font-semibold">
            <Link to="/projects">
              View All Projects <ArrowRight className="ml-2 w-4 h-4" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}